import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { PrivacyPage } from '@presentation/pages';
import type { FC } from 'react';

export const PrivacyPageController: FC = () => {
  const { translate } = useRouter();

  return (
    <>
      <SeoController
        title={translate('privacyPolicy.seo.title')}
        description={translate('privacyPolicy.seo.description')}
      />
      <PrivacyPage />
    </>
  );
};
